import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export function successToastr(message: string) {
    toast.success(message, {
        position: 'top-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        theme: 'colored',
        icon: false
    });
}
export function errorToastr(message: string) {
    toast.error(message, {
        position: 'top-left',
        autoClose: 20000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        theme: 'colored',
        icon: false
    });
}
